import { RootState } from 'store/store';

export const selectCustomerData = (state: RootState) => state.customer.customer;
export const selectCustomerRequestStatus = (state: RootState) => state.customer.customerRequestStatus;
